const state = {
  elasticUpdateDelay: 1100,
  showConfirmModal: false,
  modalCloseConfirmed: false,
}

const getters = {
  menu(state, getters, rootState, rootGetters) {
    const menuItems = [
      // {
      //   title: 'Dashboard',
      //   path: '/',
      //   icon: 'odometer',
      //   menu: 'dashboard',
      // },
    ]

    if (rootGetters['me/canSearchProvider']) {
      menuItems.push({
        title: 'Providers',
        path: '/providers',
        icon: 'user',
        menu: 'providers',
      },)
    } else if (rootGetters['me/canReadProvider']) {
      menuItems.push({
        title: 'Provider',
        path: `/providers/${rootGetters['me/meProviderId']}`,
        icon: 'user',
        menu: 'providers',
      })
    }

    if (rootGetters['me/canSearchProviderProduct']) {
      menuItems.push({
        title: 'Provider Products',
        path: '/provider-products',
        icon: 'document',
        menu: 'provider-products',
      })
    }

    const supplierId = rootGetters['me/meSupplierId']

    if (rootGetters['me/canSearchSupplier']) {
      menuItems.push({
        title: 'Suppliers',
        path: '/suppliers',
        icon: 'box',
        menu: 'suppliers',
      })
    } else if (rootGetters['me/canReadSupplier'] && supplierId) {
      menuItems.push({
        title: 'Supplier',
        path: `/suppliers/${supplierId}`,
        icon: 'box',
        menu: 'suppliers',
      })
    }

    if (rootGetters['me/canSearchSupplierProduct']) {
      menuItems.push({
        title: 'Supplier Products',
        path: '/supplier-products',
        icon: 'circle-check',
        menu: 'supplier-products',
      })
    }

    if (rootGetters['me/canSearchOrder']) {
      menuItems.push({
        title: 'Orders',
        path: '/orders',
        icon: 'document',
        menu: 'orders',
      })
    }

    if (rootGetters['me/canSearchOrderItems']) {
      menuItems.push({
        title: 'Order Items',
        path: '/order-items',
        icon: 'document',
        menu: 'order-items',
      })
    }

    if (rootGetters['me/canSearchContract']) {
      menuItems.push({
        title: 'Contracts',
        path: '/contracts',
        icon: 'link',
        menu: 'contracts',
      })
    }

    if (rootGetters['me/canSearchCategoryTree']) {
      menuItems.push({
        title: 'Product Category Trees',
        path: '/product-category-trees',
        icon: 'notebook-2',
        menu: 'product-category-trees',
      })
    }

    if (rootGetters['me/canReadApiKey']) {
      menuItems.push({
        title: 'API Keys',
        path: '/api-keys',
        icon: 'key',
        menu: 'api-keys',
      })
    }

    return menuItems
  },
  showConfirmModal: state => state.showConfirmModal,
  modalCloseConfirmed: state => state.modalCloseConfirmed,
}

const mutations = {
  TOGGLE_CONFIRM_MODAL: (state, { show, confirmed = false }) => {
    state.showConfirmModal = show
    state.modalCloseConfirmed = confirmed
  },
}

const actions = {
  TOGGLE_CONFIRM_MODAL({ commit }, payload) {
    commit('TOGGLE_CONFIRM_MODAL', payload)
  },
}


export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
